<template>
	<v-container fluid style="height:100%">
		<v-row>
			<v-col cols="12" sm="2" md="2">
				<div class="title">{{$vuetify.lang.t('$vuetify.custom.role.role')}}</div>
			    <element-tree
		    	:data="roleArray"
		    	:check='false'
		    	:onClickNode="true"
		    	@return-current="returnCurrent"
		    	ref="roleTree"
		    	></element-tree>
			</v-col>
			<v-col cols="12" sm="1" md="1"></v-col>
			<v-col cols="12" sm="2" md="2">
				<div class="title">{{$vuetify.lang.t('$vuetify.custom.user.user')}}</div>
				<element-tree
		    	:data="items"
		    	:expanded="expanded"
		    	@return-all="returnAll"
		    	ref="userTree"
		    	></element-tree>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="5" md="5">
		    	<div class="my-2" style="text-align:center;" @click="saveUserRoleRelation">
		        	<v-btn large color="primary">{{$vuetify.lang.t('$vuetify.custom.preservation')}}</v-btn>
		      	</div>
	      	</v-col>
      	</v-row>
  	</v-container>
</template>
<style></style>
<script>
	import ElementTree from '@/components/tree/ElementTree'
	export default{
		data(){
			return{
				expanded:[],//默认展开
				roleArray:[],//角色列表
				userChecked:[],//选中用户
				selectedRoleId:'',//当前选中角色
		        items: [],//用户树
                userDeal:false,//用户关系修改标识

			}
		},
		computed:{

		},
		watch:{

		},
		mounted(){
			this.getTree();
			this.listRole();
		},
		methods:{
			//保存角色用户关系
			saveUserRoleRelation(){
				if(!this.userDeal){
                    this.$dialog.alert("请操作后再保存");
				}else{
                    let obj = {
                        roleId:this.selectedRoleId,
                        userIds:this.userChecked
                    }
                    this.$api.sysUserRole.saveUserRoleRelation(obj).then(data =>{
                        if(data.flag){
                            this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.preservation') + this.$vuetify.lang.t('$vuetify.custom.success'));
                        }else{
                            this.$dialog.alert(data.msg)
                        }
                    })
                }

			},
			//获取当前选中角色
			returnCurrent(val){
                this.userDeal = false;
                this.userChecked = [];
				this.queryUserRoleRelation(val.id);
				this.selectedRoleId = val.id;
			},
			//获取选中用户
			returnAll(val){
                this.userChecked = [];
			    this.userDeal = true;
				for(let v of val){
					if(v.indexOf('-') != -1){
						let str = v.substr(v.indexOf('-')+1);
						// this.userChecked = [];
						this.userChecked.push(str);
					}
				}
			},
			//查询与当前选中角色绑定的用户
			queryUserRoleRelation(roleId){
				this.$api.sysUserRole.listUserRoleRelation(roleId).then(data =>{
					if(data.flag){
						let array = [];
						array = [...data.data];
						this.$refs.userTree.setCheckedKeys(array);
					}
				})
			},
			//查询角色
			async listRole(){
				await this.$api.sysUserRole.listRole().then(data =>{
					if(data.flag){
						this.roleArray = data.data;
					}
				})
                this.selectedRoleId = this.roleArray[0].id;
				this.$refs.roleTree.setCurrentKey(this.roleArray[0].id);
				this.queryUserRoleRelation(this.roleArray[0].id);

			},
			//查询用户树
			async getTree(){
				await this.$api.sysUserOrganization.treeUserOrganization().then(data =>{
					if(data.flag){
						this.items = data.data;
						 let array = [];
						 array.push(data.data[0].id);
						 this.expanded = array;
					}
				})
			},
			//定时任务(暂留)
			timer(){
				var timer = setInterval(function(){let i = document.querySelector(".v-treeview-node__root button"); if(i){i.click();clearInterval(timer)}},200)
			},

		},
		components:{
			ElementTree
		}
	}
</script>
<style scoped>
/*标题样式*/
	.title{
		background:rgb(21, 101, 192);
		text-align:center;
		color:white;
		border-radius:20px;
	}
</style>
